import { useStore } from "@src/utils/hooks";
import { FormMode } from "@src/utils/types";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Container } from "../components";
import { InvoiceStore, InvoiceStoreContext, InvoiceTypeEnum } from "../store";

interface CreateProps {
  type: InvoiceTypeEnum;
}

const Create = observer(function Create(props: CreateProps) {
  const appStore = useStore();
  const [store] = useState(
    () => new InvoiceStore(appStore, true, props.type, FormMode.CREATE),
  );
  return (
    <InvoiceStoreContext.Provider value={store}>
      <Container />
    </InvoiceStoreContext.Provider>
  );
});

export default {
  Outgoing: () => <Create type={InvoiceTypeEnum.Outgoing} />,
  CreditNote: () => <Create type={InvoiceTypeEnum.CreditNote} />,
  Proforma: () => <Create type={InvoiceTypeEnum.Proforma} />,
};
